import React from 'react';
import ReactDOM from 'react-dom';
import { withCookies, Cookies } from 'react-cookie';
import { SearchBar, List, Tabs, WhiteSpace, Badge, Picker, Modal } from 'antd-mobile';
import { Link } from 'react-router-dom';
import { Radio } from 'antd';

import "./index.css";
import { _getDataFormList } from "../../server";
import MyListView from "./MyListView";

const alert = Modal.alert;

const tabs = [
    { title: <Badge>我提交的</Badge> },
    { title: <Badge>我相关的</Badge> }
];

const formStatusData = [
    { value: "-100", label: "全部" },
    { value: "2", label: "审批中" },
    { value: "0", label: "已退审" },
    { value: "1", label: "已审批" },
    { value: "-1", label: "已关闭" }
];

class MinePage extends React.Component {

    myListView = [];
    hasFirstReceive = false;

    constructor(props) {
        super(props)
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);

        let activeTap = window.sessionStorage.getItem("mine_active_tab");
        if (activeTap) {
            activeTap = parseInt(activeTap);
        } else {
            activeTap = 0;
        }

        this.state = {
            formStatus: [formStatusData[0].value],
            listForms: [],
            listType: 1,
            activeTap: activeTap,
            height: document.documentElement.clientHeight,
        };
    }

    componentWillUnmount() {
        if (this.state.activeTap>=0) {
            window.sessionStorage.setItem("mine_active_tab", this.state.activeTap);
        }
    }

    componentWillReceiveProps() {
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        if (!this.hasFirstReceive) {
            this.hasFirstReceive = true;
            return;
        }
        if (window.sessionStorage.getItem("index_tab") !== "mineTab") {
            return;
        }
        this.myListView[this.state.activeTap].refreshList(this.state.formStatus[0], [], this.state.listType);
    }

    bindRef_0 = ref => { this.myListView[0] = ref }
    bindRef_1 = ref => { this.myListView[1] = ref }

    onPickerChange = (value) => {
        this.setState({ formStatus: value });
        this.myListView[this.state.activeTap].refreshList(value[0], [], this.state.listType);
    }

    render() {
        return <Tabs tabs={tabs} initialPage={this.state.activeTap} 
                    tabBarActiveTextColor="#ff884d"
                    prerenderingSiblingsNumber={2}
                    useOnPan={false}
                    tabBarUnderlineStyle={{border:"1px #ff884d solid"}}
                    distanceToChangeTab={0.4}
                    onChange={(tab, index) => { 
                        switch (index) {
                            case 0:
                                this.setState({listType: 1, activeTap: 0}, this.myListView[0].refreshList(this.state.formStatus[0], [], 1));
                                break;
                            case 1:
                                this.setState({listType: 5, activeTap: 1}, this.myListView[1].refreshList(this.state.formStatus[0], [], 5));
                                break;
                            default:
                                console.log('onChange', index, tab);
                                break;
                        }
                     }}>
                  <div style={{ height: '100%', backgroundColor: '#fff', overflow: "hidden" }}>
                      <div className="formControl">
                        <Picker data={formStatusData} cols={1} onChange={(e) => this.onPickerChange(e)} value={this.state.formStatus}>
                              <List.Item arrow="horizontal" style={{border: "1px solid #e5e5e5", borderRadius: 4, minHeight:36, height:36}}>表单状态</List.Item>
                        </Picker>
                      </div>
                      <MyListView onRef={this.bindRef_0} status={[]} formStatus={this.state.formStatus[0]} listType={1} />
                  </div>
                  <div style={{ height: '100%', backgroundColor: '#fff', overflow: "hidden" }}>
                      <div className="formControl">
                        <Picker data={formStatusData} cols={1} onChange={(e) => this.onPickerChange(e)} value={this.state.formStatus}>
                              <List.Item arrow="horizontal" style={{border: "1px solid #e5e5e5", borderRadius: 4, minHeight:36, height:36}}>表单状态</List.Item>
                        </Picker>
                      </div>
                      <MyListView onRef={this.bindRef_1} status={[]} formStatus={this.state.formStatus[0]} listType={5} />
                  </div>
              </Tabs>
    }

}

export default withCookies(MinePage);